import React from 'react';
import { useAtomValue } from 'jotai';
import { Retry } from '@components/common';
import Table from '@components/common/Table';
import useAppDimension from '@components/app-analyse-network-request/utils/useDimension';
import Search from '@components/dimension-panel-hz/dimension-table/Search';
import useGrid from '@components/dimension-panel-hz/hooks/useGrid';
import { unitAtom } from '@components/metrics-panel-hz/atoms';
import { heightAtom } from '@components/dimension-panel-hz/atoms';
import { TABLE_HEIGHT_MAPPING } from '@components/dimension-panel-hz/header/Resize';
import { dimensionTraceId } from './utils/constant';
import { TableWrapper, WidgetActions } from './styled';

function AppDimensionTable({ dimension, updateGrid }) {
  const unit = useAtomValue(unitAtom);
  const height = useAtomValue(heightAtom);

  const {
    data,
    totals,
    columns,
    isFetching,
    isError,
    isEmpty,
    refetch,
    sortBy,
    onColumnSort,
    onSearch,
    searchText,
  } = useAppDimension({ dimension, unit });
  useGrid({ data, isError, isFetching, updateGrid });

  return (
    <>
      <WidgetActions>
        <Search onSearch={onSearch} text={searchText} />
      </WidgetActions>
      <TableWrapper style={{ height: TABLE_HEIGHT_MAPPING[height] }}>
        <Retry
          fetchData={refetch}
          isLoading={isFetching}
          showError={isError}
          // LoadingLayer={TableSkeleton}
          isEmpty={isEmpty}
          progress={true}
        >
          <Table
            fixed={true}
            data={data}
            frozenData={dimension === dimensionTraceId ? [] : [totals]}
            columns={columns}
            headerHeight={50}
            rowHeight={45}
            rowKey={dimension}
            sortBy={sortBy}
            onColumnSort={onColumnSort}
          />
        </Retry>
      </TableWrapper>
    </>
  );
}

export default AppDimensionTable;
